import clsx from "clsx"
import React from "react"

const Tag = ({ label, className = "text-sm", style, onClick = () => {} }) => {
	const finalLabel = label?.replace(/-/g, " ")
	return (
		<React.Fragment>
			{label === "BRATZ®" ? (
				<div
					className={clsx(
						"px-2.5 py-1 border border-[#512675] text-[#512675] bg-white rounded-full uppercase content-center",
						className
					)}
					onClick={onClick}
				>
					{finalLabel}
				</div>
			) : (
				<div
					className={clsx(
						"px-2.5 py-1 rounded-full uppercase content-center",
						className,
						finalLabel === "new & hot"
							? "bg-[#D30000] text-white"
							: "bg-white text-black"
					)}
					onClick={onClick}
				>
					{finalLabel}
				</div>
			)}
		</React.Fragment>
	)
}

export default Tag
